import RewardNew from './RewardNew.vue';

export const rewardRoutesV2 = [
    {
        path: '/reward-new',
        name: 'RewardNew',
        meta: {
            requiresAuth: true,
            accessId: 'reward',
        },
        component: RewardNew
    }
]



